// extracted by mini-css-extract-plugin
export default {"application-form-container":"applicationForm_application-form-container__i1jBn","form":"applicationForm_form__pDLAV"};